"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _require = require("../../constants/loggingLevels"),
  ERROR = _require.ERROR,
  WARNING = _require.WARNING;
var NewRelicPresenter = require("../../presenters/NewRelicPresenter");
var distilledLevels = {
  ERROR: ERROR,
  WARNING: WARNING
};
var NewRelicErrorProcessor = /*#__PURE__*/function () {
  function NewRelicErrorProcessor() {
    (0, _classCallCheck2["default"])(this, NewRelicErrorProcessor);
  }
  return (0, _createClass2["default"])(NewRelicErrorProcessor, [{
    key: "processPayload",
    value: function processPayload(level, payloads) {
      if (distilledLevels[level]) {
        return NewRelicPresenter.distillPayloads.apply(NewRelicPresenter, (0, _toConsumableArray2["default"])(payloads));
      }
      return payloads;
    }
  }]);
}();
var instance = new NewRelicErrorProcessor();
module.exports = exports = instance;